import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Series(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.series().length) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This condition is necessary until we update the logic to fit the new types package.
  if (!listing.series?.id) {
    return false;
  }

  // Legacy alterations. This allows us to filter on legacy conditions without having to include them in the url.
  const _value = [...this.filteringService.series()];

  if (_value.includes('courtyard-villas')) {
    _value.push(
      'bungalow-villas',
      'cabana-villas',
      'creekside-villas',
      'edgewater-villas',
      'garden-villas',
      'keys-villas',
      'savanna-villas',
    );
  }

  if (_value.includes('cottage-homes')) {
    _value.push('ranch-homes');
  }

  // Determine if the listing matches the filter.
  if (!_value.includes(listing.series.id)) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
